import React, { useContext } from 'react';
import {
  Image, Text, TouchableOpacity, View,
} from 'react-native';
import * as DocumentPicker from 'expo-document-picker';
import { LocStr } from '../utils/Utils';
import * as K from '../constants/k';
import { Context as PayKeyDashboardServerContext } from '../context/PayKeyDashboardServerContext';
import {
  file_str,
  Please_select_a,
  Please_select_file,
  success_category,
  Upload_str,
} from '../utils/DictionaryManagementUtils';
import { img_upload } from '../utils/ImagesManagementUtils';

//= ========================================================================
const MyUploadButton = ({
  wantFont = false,
  isDisabled = false,
  onFileSelected,
  onFileError,
  onFileLoading,
  language,
}) => {
  const { uploadFile } = useContext(PayKeyDashboardServerContext);

  const _pickDocument = async () => {
    try {
      const fileType = wantFont ? '*/*' : K.IMAGE_MIME_TYPE;

      const result = await DocumentPicker.getDocumentAsync({
        type: fileType,
      });

      if (result.cancelled) {
      } else if (result.type === success_category) {
        // check file type selected:
        if (wantFont) {
          if (
            !result.name.endsWith('.ttf')
              && !result.name.endsWith('.otf')
          ) {
            onFileError(LocStr(Please_select_file, language));
            return;
          }
        } else if (!result.name.endsWith(`.${K.IMAGE_FILE_EXT}`)) {
          onFileError(
            LocStr(Please_select_a + K.IMAGE_FILE_EXT + file_str, language),
          );
          return;
        }

        await serverUploadFile(result, fileType);
      }
    } catch (errMsg) {
      console.log(errMsg);
    }
  };

  // ######################################################################
  // ###   S e r v e r   s t u f f
  // ######################################################################

  const serverUploadFile = async (fileObj, fileType) => {
    try {
      onFileLoading(true, fileObj.name);

      uploadFile(
        global.token,
        fileObj,
        fileType,
        (result) => {
          onFileLoading(false, '');
          onFileSelected(fileObj.name, fileObj.uri, result.imageId);
        },
        (errMsg) => {
          onFileLoading(false, '');
          onFileError(errMsg);
          console.log(errMsg);
        },
      );
    } catch (err) {}
  };

  // ######################################################################

  return (
    <View
      style={{
        width: 106,
        height: 30,
        marginTop: 1,
        marginLeft: 1,
        backgroundColor: '#fff',
        borderRadius: 4,
        flexDirection: 'row',
      }}
    >
      <TouchableOpacity
        style={{ width: 106, height: 30 }}
        onPress={() => {
          _pickDocument();
        }}
        activeOpacity={isDisabled ? 0.5 : 1}
        disabled={isDisabled}
      >
        <Image
          fadeDuration={0}
          style={{
            width: 14, height: 14, marginLeft: 16, marginTop: 8,
          }}
          source={img_upload}
        />
        <Text
          style={{
            width: 54,
            height: 20,
            marginTop: 6,
            marginLeft: 38,
            fontFamily: 'Rubik-Regular',
            fontSize: 16,
            color: '#001a2f',
            position: 'absolute',
            opacity: isDisabled ? 0.5 : 1,
          }}
        >
          {LocStr(Upload_str, language)}
        </Text>
      </TouchableOpacity>
    </View>
  );
};

export default MyUploadButton;
